<template>
	<div class="card">
		<div class="card-body vstack gap-3">
			<div class="vstack lh-sm">
				<div>Cantidad de clientes</div>
				<div class="text-muted text-sm">Por estado</div>
			</div>
			<CustomerCommonStatusOptionList onSelect="redirect" />
		</div>
		<div class="card-footer">
			<router-link :to="{ name: 'customer.index' }" class="link-primary">Ver todos<i class="bi bi-chevron-right ps-1 text-xs"></i></router-link>
		</div>
	</div>
</template>